export default {
 pageTitle: '香港公司注册',
 heroDesc: '快速、便捷、专业的香港公司注册服务,助力企业国际化发展',
 advantagesTitle: '香港公司的优势',
 advantagesSubtitle: '为什么选择在香港注册公司？',
 advantage1Title: '税率低廉',
 advantage1Desc: '香港采用地域来源原则征税，企业所得税率仅16.5%，且无增值税和营业税',
 advantage2Title: '法律体系完善',
 advantage2Desc: '香港拥有健全的法律体系和知识产权保护制度，为企业提供可靠保障',
 advantage3Title: '国际认可度高',
 advantage3Desc: '香港公司享有良好的国际声誉，便于开展国际贸易和投资',
 advantage4Title: '注册快捷',
 advantage4Desc: '最快1个工作日即可完成注册，手续简便高效',
 processTitle: '注册流程',
 processSubtitle: '简单四步，轻松注册香港公司',
 process1Title: '公司核名',
 process1Desc: '确认公司名称是否可用',
 process2Title: '准备资料',
 process2Desc: '提交股东董事身份证明等文件',
 process3Title: '提交申请',
 process3Desc: '向香港公司注册处提交申请',
 process4Title: '领取证书',
 process4Desc: '获取公司注册证书及商业登记证',
 solutionsTitle: '解决方案',
 solutionsSubtitle: '香港公司为您解决哪些问题？',
 solution1Title: '拓展国际市场',
 solution1Desc: '利用香港作为国际金融中心的优势，便捷开展全球业务',
 solution2Title: '优化税务结构',
 solution2Desc: '合理利用香港低税率政策，降低企业税负',
 solution3Title: '便利外汇管理',
 solution3Desc: '香港无外汇管制，资金进出自由',
 solution4Title: '提升企业形象',
 solution4Desc: '香港公司国际认可度高，增强商业信誉',
 solution5Title: '保护个人隐私',
 solution5Desc: '董事股东信息可以选择不公开',
 solution6Title: '法律保障完善',
 solution6Desc: '完善的法律体系保护企业权益',
 ctaTitle: '准备好注册香港公司了吗？',
 ctaDesc: '立即联系我们，专业顾问为您提供一对一咨询服务',
 ctaButton: '立即咨询',
}
